import * as yup from 'yup'

export const validationSchemaSummary = yup.object({
  startDate: yup.number().required('Field is required'),
  endDate: yup.number().required('Field is required'),
})
